import React from 'react';
import styles from './ElevenPointRatingScale.scss';

type ElevenPointRatingScaleAnimationProps = {
  isFirstItem: boolean;
  isLastItem: boolean;
  isSelectedItem: boolean;
  likertColor: string;
};

export const ElevenPointRatingScaleAnimation = ({
  isFirstItem,
  isLastItem,
  isSelectedItem,
  likertColor,
}: ElevenPointRatingScaleAnimationProps) => {
  return (
    <div
      aria-hidden="true"
      className={`absolute h-[31px] w-[30px] max-sm:rounded-full rounded-none ${
        isFirstItem ? `${styles.firstItemBorder}` : ''
      } ${isLastItem ? `${styles.lastItemBorder}` : ''} ${
        isSelectedItem ? `${likertColor} animate-pop` : ''
      }`}
    />
  );
};
